/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { ParallaxBanner, ParallaxBannerLayer } from 'react-scroll-parallax';
import { Select, type SelectChangeEvent } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { AnimatePresence, motion } from 'framer-motion';

import lantern from '../assets/banner/newYear/lantern_revised.webp';
import mobileBackground from '../assets/banner/newYear/mob_mt_cover_bg.webp';
import mobileRankingBackground from '../assets/banner/newYear/mob_mt_rb_bg_full.webp';
import mobileConfetti from '../assets/banner/newYear/mob_mt_rb_conffeti.webp';
import mobileStairs from '../assets/banner/newYear/mob_mt_rb_stairs.webp';
import mobileWave1 from '../assets/banner/newYear/mob_mt_rb_wave1.webp';
import mobileWave2 from '../assets/banner/newYear/mob_mt_rb_wave2.webp';
import mobileWave3 from '../assets/banner/newYear/mob_mt_rb_wave3.webp';
import mobileWave4 from '../assets/banner/newYear/mob_mt_rb_wave4.webp';
import mobileWave5 from '../assets/banner/newYear/mob_mt_rb_wave5.webp';
import desktopCirle from '../assets/banner/newYear/mob_mt_web_cny_bg_badge_revised.webp';
import dragonEye from '../assets/banner/newYear/point_light.webp';
import desktopBackground from '../assets/banner/newYear/web_mt_cover_bg.webp';
import redGoldCloud2 from '../assets/banner/newYear/web_mt_cover_cloud_img_a.webp';
import blueGoldCloud from '../assets/banner/newYear/web_mt_cover_cloud_img_b.webp';
import redGoldCloud from '../assets/banner/newYear/web_mt_cover_cloud_img_c.webp';
import desktopStairs from '../assets/banner/newYear/web_mt_cover_stairs_revised.webp';
import desktopWave1 from '../assets/banner/newYear/web_mt_cover_wave1.png';
import desktopWave2 from '../assets/banner/newYear/web_mt_cover_wave2.webp';
import desktopWave3 from '../assets/banner/newYear/web_mt_cover_wave3.webp';
import desktopWave4 from '../assets/banner/newYear/web_mt_cover_wave4.webp';
import desktopWave5 from '../assets/banner/newYear/web_mt_cover_wave5.webp';
import mtLogo from '../assets/banner/newYear/web_mt_logo2.webp';
import mtLogo_vn from '../assets/banner/newYear/web_mt_logo2_vn.webp';
import rankingBackground from '../assets/banner/newYear/web_mt_rb_bg.webp';
import desktopFans from '../assets/banner/newYear/web_mt_rb_bg_fan.webp';
import desktopConfetti from '../assets/banner/newYear/web_mt_rb_conffeti.webp';
import newTopMasterTitleEn from '../assets/banner/newYear/web_mt_txt_rb_logo_en.webp';
import newTopMasterTitleCNSimp from '../assets/banner/newYear/web_mt_txt_rb_logo_hans_revised.webp';
import newTopMasterTitleCNTrad from '../assets/banner/newYear/web_mt_txt_rb_logo_hant_revised.webp';
import sloganEn from '../assets/banner/pc_slogan_en.png';
import sloganId from '../assets/banner/pc_slogan_id.png';
import sloganJp from '../assets/banner/pc_slogan_ja.png';
import sloganKh from '../assets/banner/pc_slogan_kh.png';
import sloganKr from '../assets/banner/pc_slogan_kr.png';
import sloganTh from '../assets/banner/pc_slogan_th.png';
import sloganVn from '../assets/banner/pc_slogan_vn.png';
import sloganHans from '../assets/banner/pc_slogan_zh-Hans.png';
import sloganHant from '../assets/banner/pc_slogan_zh-Hant.png';
import goldCrown from '../assets/banner/web_mt_icon_crown_gold.webp';
import { rankingDatesArray } from '../data';
import {
  rankingsData1, rankingsData2, rankingsData3, rankingsData4, subText, subText2, subText3, subText4, subText2025Sep,
  subText2025Dec, subText2026Jun, subText2026Jul
} from '../data/rankingsData';
import { type IBanner, type ISubText } from '../interfaces';
import { languageCodes } from '../languages/languages';

import { LoadingBanner } from './LoadingBanner';

import '../styles/Banner.scss';

export default function Banner (
  { isMobileView, showRankings, t, i18n, isChinese }: IBanner): JSX.Element {
  const [isfirstRow, setIsFirstRow] = useState<boolean>(true);
  const [loading, setLoading] =
    useState({ titleLogo: false, background: false, rankingBackground: false });
  const [resultsPointer, setResultsPointer] = useState(0);

  const handleChangeOfDate = (event: SelectChangeEvent): void => {
    setResultsPointer(Number(event.target.value));
  };

  const isCNTrad: boolean =
    i18n.resolvedLanguage === languageCodes.chineseTraditional;
  const isCNSimp: boolean =
    i18n.resolvedLanguage === languageCodes.chineseSimplified;

  const TRANSITION_DURATION: number = 0.5;

  const selectBackground = '#801F15';

  const menuItemColor = '#FFF5D9';

  const sloganImages = {
    desktop: {
      [languageCodes.chineseSimplified]: sloganHans,
      [languageCodes.chineseTraditional]: sloganHant,
      [languageCodes.english]: sloganEn,
      [languageCodes.japanese]: sloganJp,
      [languageCodes.thai]: sloganTh,
      [languageCodes.vietnamese]: sloganVn,
      [languageCodes.indonesian]: sloganId,
      [languageCodes.korean]: sloganKr,
      [languageCodes.khmer]: sloganKh
    },
    mobile: {
      [languageCodes.chineseSimplified]: sloganHans,
      [languageCodes.chineseTraditional]: sloganHant,
      [languageCodes.english]: sloganEn,
      [languageCodes.japanese]: sloganJp,
      [languageCodes.thai]: sloganTh,
      [languageCodes.vietnamese]: sloganVn,
      [languageCodes.indonesian]: sloganId,
      [languageCodes.korean]: sloganKr,
      [languageCodes.khmer]: sloganKh
    }
  };

  const getLogo = (): string => {
    console.log('i18n.resolvedLanguage', i18n.resolvedLanguage);
    const currentLang = i18n.resolvedLanguage;
    return currentLang === languageCodes.vietnamese ? mtLogo_vn : mtLogo;
  };
  
  const checkTextSlogan = (): string => {
    console.log('i18n.resolvedLanguage', i18n.resolvedLanguage);
    const currentLang = i18n.resolvedLanguage;
    const device = isMobileView ? 'mobile' : 'desktop';

    if (currentLang !== undefined && currentLang.length > 0) {
      const selectedImage = sloganImages[device][currentLang];
      if (selectedImage !== undefined && selectedImage.length > 0) {
        return selectedImage;
      }
    }
    return sloganEn;
  };

  const checkBackground = (): string => {
    if (isMobileView && !showRankings) return mobileBackground;
    if (isMobileView && showRankings) return mobileRankingBackground;
    if (!isMobileView && showRankings) return rankingBackground;
    return desktopBackground;
  };

  const checkTopMasterTitle = (): string => {
    if (isCNSimp) return newTopMasterTitleCNSimp;
    if (isCNTrad) return newTopMasterTitleCNTrad;

    return newTopMasterTitleEn;
  };

  const checkUnderlineRankings = (): string => {
    if (isfirstRow) return 'left-underline';
    if (!isfirstRow) return 'right-underline';

    return '';
  };
  const getSubTextForPointer = (rowIndex: number): ISubText[] => {
    if (resultsPointer === 0) {
      // 2025-09: 每行2个玩家，每个玩家都有独立的金额和时间信息
      // 第1行: 索引0,1 | 第2行: 索引2,3 | 第3行: 索引4,5 | 第4行: 索引6,7
      const startIndex = (rowIndex - 1) * 2;
      return [subText2026Jul[startIndex], subText2026Jul[startIndex + 1]];
    } else if (resultsPointer === 1) {
      const startIndex = (rowIndex - 1) * 2;
      return [subText2026Jun[startIndex], subText2026Jun[startIndex + 1]];
    } else if (resultsPointer === 2) {
      const startIndex = (rowIndex - 1) * 2;
      return [subText2025Dec[startIndex], subText2025Dec[startIndex + 1]];
    } else if (resultsPointer === 3) {
      const startIndex = (rowIndex - 1) * 2;
      return [subText2025Sep[startIndex], subText2025Sep[startIndex + 1]];
    }
    // 其他月份的逻辑
    switch (rowIndex) {
      case 1: return subText;
      case 2: return subText2;
      case 3: return subText3;
      case 4: return subText4;
      default: return subText;
    }
  };
  // const dateOfNextTournament = (): string => {
  //   if (isCNTrad) return '敬請期待';
  //   if (isCNSimp) return '敬请期待';
  //   return 'Stay Tuned';

  //   // if (isChinese) return dates.chinese;

  //   // return dates.english;
  // };
  useEffect(() => {
    // 使用统一的图片选择逻辑
    const currentSloganImage = checkTextSlogan();

    // 加载当前语言的 slogan 图片
    const sloganImage = new Image();
    sloganImage.onload = () => {
      setLoading(prev => ({ ...prev, titleLogo: true }));
    };
    sloganImage.src = currentSloganImage;

    // 加载背景图片
    const backgroundImage = new Image();
    backgroundImage.onload = () => {
      setLoading(prev => ({ ...prev, background: true }));
    };
    backgroundImage.src = isMobileView ? mobileBackground : desktopBackground;

    // 加载排名背景图片
    const rankingBgImage = new Image();
    rankingBgImage.onload = () => {
      setLoading(prev => ({ ...prev, rankingBackground: true }));
    };
    rankingBgImage.src = isMobileView ? mobileRankingBackground : rankingBackground;
  }, [isMobileView, i18n.resolvedLanguage]); // 依赖项：当设备类型或语言改变时重新加载

  const rankingsDataComponent =
    (rankingsData: string[], textArr: ISubText[]): JSX.Element =>
      (
        <>
          {rankingsData.map((data, index) => (
            <div key={`${resultsPointer}-${index}-${data}`} className="gold-badge">
              <div className="top-text">
                <img src={goldCrown} alt="Gold Crown" width="27px" height="20px"/>
                <p className="gold-badge-title">{t(data)}</p>
              </div>
              <aside>
                <>
                  <p>{textArr[index].subText1En}</p>
                  <p className="en-p">{t(textArr[index].subText2En)}</p>
                </>
              </aside>

            </div>
          ))}
        </>);

  if (Object.values(loading).every(el => el)) {
    return (
      <div className="banner">
        <ParallaxBanner className="parallax-banner">
          <ParallaxBannerLayer
            image={checkBackground()}
            className={isMobileView ? 'cover-1-mobile' : 'cover-1'}
            key={checkBackground()}/>
          {!showRankings && (
            <>
              <ParallaxBannerLayer image={lantern} speed={5} className="lantern" />
              <ParallaxBannerLayer image={desktopCirle} speed={10} className="circle" />
            </>
          )}
          {showRankings && (
            <ParallaxBannerLayer image={desktopFans} className="fans" />
          )}
          {!isMobileView && <ParallaxBannerLayer image={blueGoldCloud} speed={12} className="cloud blue-cloud-left-1" />}
          {!isMobileView && <ParallaxBannerLayer image={redGoldCloud2} speed={12} className="cloud red-cloud-right-1" />}
          <ParallaxBannerLayer image={isMobileView ? mobileWave5 : desktopWave5} className="wave5" />
          <ParallaxBannerLayer image={isMobileView ? mobileWave4 : desktopWave4} className="wave4" />
          <ParallaxBannerLayer image={redGoldCloud} speed={12} className="cloud red-cloud-left-1" />
          <ParallaxBannerLayer image={blueGoldCloud} speed={12} className="cloud blue-cloud-right-1" />
          <ParallaxBannerLayer image={isMobileView ? mobileWave3 : desktopWave3} className="wave3" />
          <ParallaxBannerLayer image={isMobileView ? mobileWave2 : desktopWave2} className="wave2" />
          <ParallaxBannerLayer image={blueGoldCloud} speed={12} className="cloud blue-cloud-left-2" />
          <ParallaxBannerLayer image={redGoldCloud} speed={12} className="cloud red-cloud-right-2" />
          <ParallaxBannerLayer image={isMobileView ? mobileWave1 : desktopWave1} className="wave1" />
          <ParallaxBannerLayer image={isMobileView ? mobileStairs : desktopStairs} className="stairs" />
          {showRankings && (
            <ParallaxBannerLayer image={isMobileView ? mobileConfetti : desktopConfetti} className="confetti" />
          )}
          <AnimatePresence mode="wait">
            {!showRankings &&
            <>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: TRANSITION_DURATION }}
                exit={{ opacity: 0 }}>
              </motion.div>
              <motion.div
                initial={{ transform: 'rotateY(180deg)', opacity: 0, backfaceVisibility: 'hidden' }}
                animate={{ transform: 'rotateY(0deg)', opacity: 1 }}
                transition={{ duration: TRANSITION_DURATION }}
                exit={{ transform: 'rotateY(-180deg)', opacity: 0 }}>
                <ParallaxBannerLayer expanded={false} speed={15} className="mt-logo">
                  <div className="logo-container">
                    <img src={getLogo()} alt="MT logo" width={isMobileView ? '250px' : '600px'} height="auto"/>
                    <img src={dragonEye} alt="Dragon Eye" width={isMobileView ? '25px' : '50px'} height="auto" className="dragon-eye" />
                  </div>
                </ParallaxBannerLayer>
                <ParallaxBannerLayer expanded={false} speed={15} className="mt-text-slogan">
                  <img src={checkTextSlogan()} alt="MT slogan" />
                  <div className="title-logo">
                    <p>{t('stayTuned')}</p>
                    {/* {isMobileView
                      ? <>
                        <p>
                          {mobileDateFormatPart1(isChinese
                            ? dates.chinese
                            : dates.english)}
                        </p>
                        <p>
                          {mobileDateFormatPart2(isChinese
                            ? dates.chinese
                            : dates.english)}</p>
                      </>
                      : <p>{dateOfNextTournament()}</p>} */}
                  </div>
                </ParallaxBannerLayer>
              </motion.div>
            </>
            }
          </AnimatePresence>
          <AnimatePresence mode="wait">
            {showRankings && (
              <motion.div
                initial={{ transform: 'rotateY(-180deg)', opacity: 0, backfaceVisibility: 'hidden' }}
                animate={{ transform: 'rotateY(0deg)', opacity: 1 }}
                transition={{ duration: TRANSITION_DURATION }}
                exit={{ transform: 'rotateY(-180deg)', opacity: 0 }}>
                <ParallaxBannerLayer speed={10}>
                  <div className="ranking-board-container">
                    <div className="top-master-title">
                      <img src={checkTopMasterTitle()} alt="New Top Master" width={isChinese ? '150px' : '300px'} height="auto"/>
                    </div>
                    <div>
                      <p className="congrats-text" style={{ fontWeight: i18n.resolvedLanguage === languageCodes.khmer ? '400' : '600' }}>{t('topMasterCongrats')}</p>
                    </div>
                    <div className="default-date">
                      <Select
                        sx={{
                          color: menuItemColor,
                          borderRadius: '16px',
                          border: '1px solid transparent',
                          '.MuiOutlinedInput-notchedOutline': {
                            borderColor: 'transparent'
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'transparent'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'transparent'
                          },
                          '.MuiSvgIcon-root ': {
                            fill: `${menuItemColor} !important`
                          }
                        }}
                        inputProps={{
                          MenuProps: {
                            disableScrollLock: true,
                            MenuListProps: {
                              sx: {
                                backgroundColor: selectBackground
                              }
                            }
                          }
                        }}
                        value={resultsPointer.toString()}
                        onChange={handleChangeOfDate}>
                        {rankingDatesArray.map((dateObj, i) => {
                          const dateStr =
                            `${isChinese
                              ? rankingDatesArray[i]?.chinese
                              : rankingDatesArray[i]?.english}`;
                          return (
                            <MenuItem sx={{
                              bgcolor: 'black',
                              color: menuItemColor,
                              '&.Mui-selected, &.Mui-selected:hover, &.MuiMenuItem-root': {
                                background: selectBackground,
                                color: menuItemColor
                              },
                              '&.MuiMenu-paper': {
                                backgroundColor: selectBackground
                              },
                              '&.MuiMenuItem-root:hover': {
                                color: menuItemColor
                              }
                            }}
                            key={dateObj.chinese} value={i}>{dateStr}</MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                    {!isMobileView && (
                      <div className="rankings-container">
                        {resultsPointer === 0
                          ? (
                            <>
                              <div className="first-row">
                                <div className="date-line">
                                  <p>
                                    {isChinese
                                      ? rankingDatesArray[resultsPointer].date1Chinese
                                      : rankingDatesArray[resultsPointer]
                                        .date1English}
                                  </p>
                                </div>
                                {rankingsDataComponent(rankingsData1[resultsPointer], getSubTextForPointer(1))}
                              </div>
                              <div className="second-row">
                                <div className="date-line">
                                  <p>
                                    {isChinese
                                      ? rankingDatesArray[resultsPointer].date2Chinese
                                      : rankingDatesArray[resultsPointer]
                                        .date2English}
                                  </p>
                                </div>
                                {rankingsDataComponent(rankingsData2[resultsPointer], getSubTextForPointer(2))}
                              </div>
                              <div className="third-row">
                                <div className="date-line">
                                  <p>
                                    {isChinese
                                      ? rankingDatesArray[resultsPointer].date3Chinese
                                      : rankingDatesArray[resultsPointer]
                                        .date3English}
                                  </p>
                                </div>
                                {rankingsDataComponent(rankingsData3[resultsPointer], getSubTextForPointer(3))}
                              </div>
                              <div className="fourth-row">
                                <div className="date-line">
                                  <p>
                                    {isChinese
                                      ? rankingDatesArray[resultsPointer].date4Chinese
                                      : rankingDatesArray[resultsPointer]
                                        .date4English}
                                  </p>
                                </div>
                                {rankingsDataComponent(rankingsData4[resultsPointer], getSubTextForPointer(4))}
                              </div>
                            </>
                            )
                          : (
                            <>
                              <div className="first-row">
                                <div className="date-line">
                                  <p>
                                    {isChinese
                                      ? rankingDatesArray[resultsPointer].date1Chinese
                                      : rankingDatesArray[resultsPointer]
                                        .date1English}
                                  </p>
                                </div>
                                {rankingsDataComponent(rankingsData1[resultsPointer], getSubTextForPointer(1))}
                              </div>
                              <div className="second-row">
                                <div className="date-line">
                                  <p>
                                    {isChinese
                                      ? rankingDatesArray[resultsPointer].date2Chinese
                                      : rankingDatesArray[resultsPointer]
                                        .date2English}
                                  </p>
                                </div>
                                {rankingsDataComponent(rankingsData2[resultsPointer], getSubTextForPointer(2))}
                              </div>
                            </>
                            )}
                      </div>
                    )}
                    {isMobileView && (
                      <div className="mobile-rankings-container">
                        <div className=
                          {`mobile-day-container ${checkUnderlineRankings()}`}>
                          <button
                            className={`${!isfirstRow ? 'disabled-btn' : ''}`}
                            onClick={() => { setIsFirstRow(true); }}>
                            {(isChinese
                              ? rankingDatesArray[resultsPointer].date1Chinese
                              : rankingDatesArray[resultsPointer].date1English)}
                          </button>
                          <button
                            className={`${isfirstRow ? 'disabled-btn' : ''}`}
                            onClick={() => { setIsFirstRow(false); }}>
                            {(isChinese
                              ? rankingDatesArray[resultsPointer].date2Chinese
                              : rankingDatesArray[resultsPointer].date2English)}
                          </button>
                        </div>
                        <div className="mobile-first-row">
                          {// resultsPointer === 1
                          //   ? (
                          //     <>
                          //       {isfirstRow && (
                          //         <>
                          //           <div className="mobile-week-row">
                          //             {rankingsDataComponent(
                          //               rankingsData1[resultsPointer], getSubTextForPointer(1))}
                          //           </div>
                          //           <div className="mobile-week-row">
                          //             {rankingsDataComponent(
                          //               rankingsData2[resultsPointer], getSubTextForPointer(2))}
                          //           </div>
                          //         </>
                          //       )}
                          //       {!isfirstRow && (
                          //         <>
                          //           <div className="mobile-week-row">
                          //             {rankingsDataComponent(
                          //               rankingsData3[resultsPointer], getSubTextForPointer(3))}
                          //           </div>
                          //           <div className="mobile-week-row">
                          //             {rankingsDataComponent(
                          //               rankingsData4[resultsPointer], getSubTextForPointer(4))}
                          //           </div>
                          //         </>
                          //       )}
                          //     </>
                          //     )
                          //   :
                          (
                            <>
                              {isfirstRow &&
                                rankingsDataComponent(
                                  rankingsData1[resultsPointer], getSubTextForPointer(1))}
                              {!isfirstRow &&
                                rankingsDataComponent(
                                  rankingsData2[resultsPointer], getSubTextForPointer(2))}
                            </>
                            )}
                        </div>
                      </div>
                    )}
                  </div>
                </ParallaxBannerLayer>
              </motion.div>
            )}
          </AnimatePresence>
        </ParallaxBanner>
      </div>
    );
  }

  return <LoadingBanner />;
};
